"use strict";

exports.__esModule = true;
exports.default = void 0;
var _invert = _interopRequireDefault(require("./invert.js"));
var _escapeMap = _interopRequireDefault(require("./_escapeMap.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Internal list of HTML entities for unescaping.
var _default = exports.default = (0, _invert.default)(_escapeMap.default);